
import { forEach } from 'lodash';
import PGSHelper from '../../helpers/PGSHelper.js';
let pgsHelper = new PGSHelper();
export default class ReporteZ {
  monedaDefault = "";
  static totalSistema = 0;
  static totalSistemaOtros = 0;
  static subTotalProductos = 0;
  static taxProductos = 0;
  static totalPropinas = 0;
  static totalPropinasOtros=0;
  constructor() {

  }

  static getDocData(mainData) {

    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTableMeseros(mainData.processedDataMesero,mainData.porcentaje)
    let getFirmas = this.getFirmas(mainData.processedDataMesero,mainData.porcentaje)
    let docDefinition = {
      pageMargins: [ 20, 20, 20, 20],
      content: [
        //header
        {
          columns: [
            {
              // star-sized columns fill the remaining space
              // if there's more than one star-column, available width is divided equally
              width: '25%',
              text: ''
            },
            {
              // fixed width
              width: '50%',
              alignment: 'center',
              bold: true,
              text: [
                'PAGO MESEROS BOKKA\n',
                '' + mainData.FI + " a " + mainData.FF + "\n",
              ]
            },
            {
              // % width
              width: '25%',
              bold: true,
              text: [
                'Generado: ' + mainData.FG + '\n',
                'Hora: ' + mainData.HG + '\n',
              ]
            }
          ],
          // optional space between columns
          columnGap: 10
        },
        {
          columns: [
            {
              // fixed width
              width: '100%',
              table: {
                widths: "*",
                body: getTable
              }
            },
          ],
          margin: [0, 0, 0, 0],
        },
        {
          pageBreak: 'before',
          columns: [
            {
              // fixed width
              width: '100%',
              table: {
                widths: "*",
                heights: 50,
                body: getFirmas
              }
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTableMeseros(data,porcentaje) {
    let times = [
      [
        { text: 'Mesero', border: [true, true, true, true], fontSize: 12 },
        { text: 'Fecha', border: [true, true, true, true], fontSize: 12, alignment: 'center' },
        { text: 'Folio', border: [true, true, true, true], fontSize: 12 },
        { text: 'Total', border: [true, true, true, true], fontSize: 12, alignment: 'right' },
        { text: '%'+porcentaje, border: [true, true, true, true], fontSize: 12, alignment: 'right' },
        { text: 'Propinas', border: [true, true, true, true], fontSize: 12, alignment: 'right' },
        { text: 'Pago', border: [true, true, true, true], fontSize: 12, alignment: 'right' },
      ],
    ]
    data.forEach((venta)=>{
      let rowToAdd = [];
      if(venta.tipo == 'venta'){
        rowToAdd = [
          { text: "", border: [true, false, true, false], fontSize: 10 },
          { text: venta.FechaVenta, border: [true, true, true, true], fontSize: 10, alignment: 'center' },
          { text: venta.Folio, border: [true, true, true, true], fontSize: 10 },
          { text: '$'+pgsHelper.formatNumber(venta.TotalVenta), border: [true, true, true, true], fontSize: 10, alignment: 'right' },
          { text: '$'+pgsHelper.formatNumber((venta.TotalVenta*Number(porcentaje))/100), border: [true, true, true, true], fontSize: 10, alignment: 'right' },
          { text: '$'+pgsHelper.formatNumber(venta.TotalesPropina.MXN), border: [true, true, true, true], fontSize: 10, alignment: 'right' },
          { text: '', border: [true, false, true, false], fontSize: 10, alignment: 'right' }
        ]
      }
      if(venta.tipo == 'header'){
        rowToAdd = [
          { text: (venta.Mesero)?venta.Mesero:"SIN MESERO", border: [true, true, true, true], fontSize: 12,colSpan: 7,fillColor:"#CCE3F4" },
        ]
      }
      if(venta.tipo == 'footer'){
        rowToAdd = [
          { text: 'Total:', border: [true, true, true, true], fontSize: 10,colSpan: 3, fillColor:"#DCDCDC"},
          { text: '', border: [true, true, true, true], fontSize: 10 ,fillColor:"#DCDCDC" },
          { text: '', border: [true, true, true, true], fontSize: 10,fillColor:"#DCDCDC" },
          { text: '$'+pgsHelper.formatNumber(venta.Total), bold: true, border: [true, true, true, true], fontSize: 10 ,fillColor:"#DCDCDC",alignment: 'right'},
          { text: '$'+pgsHelper.formatNumber((venta.Total*Number(porcentaje))/100), bold: true,border: [true, true, true, true], fontSize: 10,fillColor:"#DCDCDC",alignment: 'right' },
          { text: '$'+pgsHelper.formatNumber(venta.TotalPropinaMesero),bold: true, border: [true, true, true, true], fontSize: 10,fillColor:"#DCDCDC" ,alignment: 'right'},
          { text: '$'+pgsHelper.formatNumber(venta.TotalPropinaMesero - ((venta.Total*Number(porcentaje))/100)),bold: true, border: [true, true, true, true], fontSize: 10,fillColor:"#DCDCDC" ,alignment: 'right'},
        ]
      }
      times.push(
        rowToAdd
      )
    })



    let table = {
      border: [true, false, true, true],
      widths: ['*'],
      table: {
        body: times
      }
    }

    return times;
  }

  static getFirmas(data,porcentaje) {
    let times =  [
      [{ text: 'Mesero', border: [true, true, true, true], fontSize: 12 },
      { text: 'Total', border: [true, true, true, true], fontSize: 12,  },
      { text: '%'+porcentaje, border: [true, true, true, true], fontSize: 12, },
      { text: 'Propina Sistema', border: [true, true, true, true], fontSize: 12, },
      { text: 'Pago', border: [true, true, true, true], fontSize: 12, },
      { text: 'Firma', border: [true, true, true, true], fontSize: 12,  }]
    ]
    data.forEach((venta)=>{
      let rowToAdd = [];
      if(venta.tipo == 'footer'){

        rowToAdd = [
          { text: venta.Mesero, border: [true, true, true, true], fontSize: 10, },
          { text: '$'+pgsHelper.formatNumber(venta.Total), bold: true, border: [true, true, true, true], fontSize: 10 ,alignment: 'right'},
          { text: '$'+pgsHelper.formatNumber((venta.Total*Number(porcentaje))/100), bold: true,border: [true, true, true, true], fontSize: 10,alignment: 'right' },
          { text: '$'+pgsHelper.formatNumber(venta.TotalPropinaMesero)+ "\n" + "Aprox. "+((venta.TotalPagoTarjetas>0)?pgsHelper.formatNumber((venta.TotalPropinasTarjetas * 100)/venta.TotalPagoTarjetas):0) +" %" , bold: true, border: [true, true, true, true], fontSize: 10 ,alignment: 'right'},
          { text: '$'+pgsHelper.formatNumber(venta.TotalPropinaMesero - ((venta.Total*Number(porcentaje))/100)), bold: true, border: [true, true, true, true], fontSize: 10 ,alignment: 'right'},
          { text: " ", bold: true,border: [true, true, true, true], fontSize: 10,alignment: 'center' },
        ]
        times.push(
          rowToAdd
        )
      }
    })



    let table = {
      border: [true, false, true, true],
      widths: ['*'],
      heights: 60,
      table: {
        body: times
      }
    }

    return times;
  }



}